import { computed, effect, signal } from '@preact/signals-react'

export const _dataSignal = signal(new Map())
export const debugDataSignal = computed(() => {
    // return the data in a format that the debug accordion component expects
    let data = []
    for(const [key, value] of _dataSignal.value) {
        data.push({name: key, data: value})
    }

    return data
})